import angular from 'angular';

import FilePreviewComponent from './components/file-preview/file-preview-component';

export default angular.module('file-preview', []).component('filePreview', new FilePreviewComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/file-preview/file-preview-module.js